import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
  isAuthenticated: boolean;
}

const ProtectedRoute = ({ isAuthenticated }: ProtectedRouteProps) => {
  return <>{isAuthenticated ? <Outlet /> : <Navigate to='/login' replace />}</>;
};

export default ProtectedRoute;
